import _prop from "ramda/src/prop";
import _pipe from "ramda/src/pipe";
import _propSatisfies from "ramda/src/propSatisfies";
import _allPass from "ramda/src/allPass";
import _test from "ramda/src/test";
import _typeof from "@babel/runtime/helpers/typeof";
import _curry from "ramda/src/curry";
import _equals from "ramda/src/equals";
var isArray = Array.isArray;
export { isArray };
export var isNull = _equals(null);
export var isInstanceOf = _curry(function (cons, thing) {
  return thing instanceof cons;
});
export var isTypeOf = _curry(function (type, thing) {
  return _typeof(thing) === type;
});
export var isFunction = isTypeOf('function');
export var isString = isTypeOf('string');
export var isEmptyString = function isEmptyString(str) {
  return str === '';
};
export var isNumber = isTypeOf('number');
export var isBoolean = isTypeOf('boolean');
export var isUndefined = isTypeOf('undefined');
export var isObject = function isObject(obj) {
  return isTypeOf('object', obj) && !isNull(obj) && !isArray(obj);
};
export var isNumeric = _test(/^[0-9]+$/);
export var isPromise = _allPass([isObject, _propSatisfies(isFunction, 'then'), _propSatisfies(isFunction, 'catch')]);
export var isStream = _allPass([isObject, _pipe(_prop('pipe'), isFunction)]);
export var isIterator = _allPass([isObject, _propSatisfies(isFunction, 'next'), _propSatisfies(isFunction, 'throw')]);
export var isEmail = _test(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);